import type { DrawState } from './slices';
import { buttonSlice, drawSlice, filtersSlice } from './slices';
import type { DrawOptions } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const {
  Provider: DrawProvider,
  useStore: useDrawStore,
  createStore: createDrawStore,
} = zustandStoreFactory<DrawState>(
  (...args) => ({
    ...drawSlice(...args),
    ...filtersSlice(...args),
    ...buttonSlice(...args),
  }),
  'Draw',
);

export const { OptionsProvider: DrawOptionsProvider, useOptions: useDrawOptions } = getOptionsProvider<DrawOptions>();
